class k {
  constructor(t = "") {
    this._lines = [], this._version = 0, this.setText(t);
  }
  // Get line at index
  getLine(t) {
    return this._lines[t] || "";
  }
  // Get all lines
  getLines() {
    return [...this._lines];
  }
  // Get total number of lines
  getLineCount() {
    return this._lines.length;
  }
  // Get total text content
  getText() {
    return this._lines.join(`
`);
  }
  // Set entire text content
  setText(t) {
    this._lines = t.split(`
`), this._version++;
  }
  // Get text in a range
  getTextInRange(t) {
    if (t.start.line === t.end.line)
      return this.getLine(t.start.line).substring(t.start.column, t.end.column);
    const e = [];
    e.push(this.getLine(t.start.line).substring(t.start.column));
    for (let s = t.start.line + 1; s < t.end.line; s++)
      e.push(this.getLine(s));
    return t.end.line < this.getLineCount() && e.push(this.getLine(t.end.line).substring(0, t.end.column)), e.join(`
`);
  }
  // Replace text in range
  replaceRange(t, e) {
    const s = this.getTextInRange(t);
    if (t.start.line === t.end.line) {
      const i = this.getLine(t.start.line), n = i.substring(0, t.start.column) + e + i.substring(t.end.column);
      this._lines[t.start.line] = n;
    } else {
      const i = this.getLine(t.start.line), n = this.getLine(t.end.line), o = i.substring(0, t.start.column) + e, h = n.substring(t.end.column), r = e.split(`
`);
      r[0] = o + r[0], r[r.length - 1] = r[r.length - 1] + h, this._lines.splice(t.start.line, t.end.line - t.start.line + 1, ...r);
    }
    return this._version++, { range: t, text: e, oldText: s };
  }
  // Insert text at position
  insertText(t, e) {
    const s = { start: t, end: t };
    return this.replaceRange(s, e);
  }
  // Delete text in range
  deleteRange(t) {
    return this.replaceRange(t, "");
  }
  // Convert position to offset
  positionToOffset(t) {
    let e = 0;
    for (let s = 0; s < t.line; s++)
      e += this.getLine(s).length + 1;
    return e += t.column, e;
  }
  // Convert offset to position
  offsetToPosition(t) {
    let e = t;
    for (let s = 0; s < this.getLineCount(); s++) {
      const i = this.getLine(s).length;
      if (e <= i)
        return { line: s, column: e };
      e -= i + 1;
    }
    return {
      line: this.getLineCount() - 1,
      column: this.getLine(this.getLineCount() - 1).length
    };
  }
  // Validate position
  isValidPosition(t) {
    return !(t.line < 0 || t.line >= this.getLineCount() || t.column < 0 || t.column > this.getLine(t.line).length);
  }
  // Validate range
  isValidRange(t) {
    return this.isValidPosition(t.start) && this.isValidPosition(t.end);
  }
  // Get version for change tracking
  getVersion() {
    return this._version;
  }
  // Clone the model
  clone() {
    const t = new k();
    return t._lines = [...this._lines], t._version = this._version, t;
  }
}
class P {
  constructor(t) {
    this.gutterWidth = 50, this.lineHeight = 21, this.container = t, this.createDOM();
  }
  createDOM() {
    this.container.innerHTML = "";
    const t = document.createElement("div");
    this.editorContainer = t, t.style.cssText = `
      position: relative;
      display: flex;
      width: 100%;
      height: 100%;
      background: var(--editor-background, #1e1e1e);
      color: var(--editor-foreground, #f8f9fa);
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 14px;
      line-height: ${this.lineHeight}px;
      /* make the outer container the single scrollable element so gutter and content scroll together */
      overflow: auto;
    `, this.lineNumbersElement = document.createElement("div"), this.lineNumbersElement.setAttribute("data-editor-gutter", "true"), this.lineNumbersElement.style.cssText = `
      display: table-cell;
      vertical-align: top;
      width: ${this.gutterWidth}px;
      background: var(--editor-gutter-background, #252526);
      color: var(--editor-gutter-foreground, #858585);
      padding: 0 8px 0 0;
      text-align: right;
      border-right: 1px solid var(--editor-gutter-border, #3e3e42);
      user-select: none;
      z-index: 1;
    `, this.contentElement = document.createElement("div"), this.contentElement.style.cssText = `
      display: table-cell;
      vertical-align: top;
      padding: 0 12px;
      background: transparent;
      border: none;
      outline: none;
      white-space: pre;
      overflow-x: auto;
      overflow-y: visible;
      min-height: 400px;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      color: inherit;
      tab-size: 2;
      -moz-tab-size: 2;
    `, this.contentElement.contentEditable = "true", this.contentElement.spellcheck = !1;
    const e = document.createElement("div");
    e.setAttribute("data-editora-editor", "true"), e.style.cssText = "display: table; table-layout: fixed; width: 100%; height: 100%;", e.appendChild(this.lineNumbersElement), e.appendChild(this.contentElement), t.appendChild(e), this.container.appendChild(t), this.updateLineNumbers(1);
  }
  // Update line numbers
  updateLineNumbers(t) {
    const e = Math.max(t, 20), s = Array.from({ length: e }, (i, n) => n + 1);
    this.lineNumbersElement.innerHTML = s.map((i) => `<div style="height: ${this.lineHeight}px; line-height: ${this.lineHeight}px; padding-right: 12px;">${i}</div>`).join("");
  }
  // Get content element
  getContentElement() {
    return this.contentElement;
  }
  // Get line numbers element
  getLineNumbersElement() {
    return this.lineNumbersElement;
  }
  // Get text content
  getText() {
    return this.contentElement.textContent || "";
  }
  // Set text content
  setText(t) {
    this.contentElement.textContent = t;
    const e = t.split(`
`).length;
    this.updateLineNumbers(e);
  }
  // Set inner HTML (used for syntax highlighted content)
  setHTML(t) {
    const e = /&lt;|&gt;/.test(t), s = /<span\b/i.test(t), i = /<[^>]+>/.test(t);
    e && s ? this.contentElement.innerHTML = t : i && !e ? this.contentElement.textContent = t : this.contentElement.innerHTML = t;
    const o = (this.contentElement.textContent || "").split(`
`).length;
    this.updateLineNumbers(o);
  }
  // Get cursor position from DOM selection
  getCursorPosition() {
    const t = window.getSelection();
    if (!t || t.rangeCount === 0)
      return { line: 0, column: 0 };
    const e = t.getRangeAt(0), s = e.cloneRange();
    s.selectNodeContents(this.contentElement), s.setEnd(e.endContainer, e.endOffset);
    const n = s.toString().split(`
`);
    return {
      line: n.length - 1,
      column: n[n.length - 1].length
    };
  }
  // Set cursor position
  setCursorPosition(t) {
    const s = this.getText().split(`
`), i = Math.min(t.line, s.length - 1), n = Math.min(t.column, s[i]?.length || 0);
    let o = 0;
    for (let a = 0; a < i; a++)
      o += s[a].length + 1;
    o += n;
    const h = document.createRange(), r = window.getSelection();
    let l = 0, c = null, d = 0;
    const f = document.createTreeWalker(
      this.contentElement,
      NodeFilter.SHOW_TEXT,
      null
    );
    let g;
    for (; g = f.nextNode(); ) {
      const a = g.textContent?.length || 0;
      if (l + a >= o) {
        c = g, d = o - l;
        break;
      }
      l += a;
    }
    if (c)
      try {
        h.setStart(c, d), h.setEnd(c, d), r?.removeAllRanges(), r?.addRange(h);
      } catch (a) {
        console.warn("Could not set cursor position:", a);
      }
  }
  // Get selection range
  getSelectionRange() {
    const t = window.getSelection();
    if (!t || t.rangeCount === 0 || t.isCollapsed)
      return;
    const e = t.getRangeAt(0), s = e.cloneRange();
    s.selectNodeContents(this.contentElement), s.setEnd(e.startContainer, e.startOffset);
    const n = s.toString().split(`
`), o = e.cloneRange();
    o.selectNodeContents(this.contentElement), o.setEnd(e.endContainer, e.endOffset);
    const r = o.toString().split(`
`);
    return {
      start: {
        line: n.length - 1,
        column: n[n.length - 1].length
      },
      end: {
        line: r.length - 1,
        column: r[r.length - 1].length
      }
    };
  }
  // Set selection range
  setSelectionRange(t) {
    this.setCursorPosition(t.start);
  }
  // Focus the editor
  focus() {
    this.contentElement.focus();
  }
  // Blur the editor
  blur() {
    this.contentElement.blur();
  }
  // Set read-only mode
  setReadOnly(t) {
    this.contentElement.contentEditable = t ? "false" : "true";
  }
  // Apply theme
  applyTheme(t) {
    Object.entries(t).forEach(([e, s]) => {
      this.container.style.setProperty(`--${e}`, s);
    });
  }
  // Scroll to position
  scrollToPosition(t) {
    const e = this.lineNumbersElement.children[t.line];
    e && e.scrollIntoView({ block: "center", behavior: "smooth" });
  }
  // Get scroll position
  getScrollTop() {
    return this.editorContainer.scrollTop;
  }
  // Set scroll position
  setScrollTop(t) {
    this.editorContainer.scrollTop = t;
  }
  // Destroy the view
  destroy() {
    this.container && this.container.parentNode && this.container.parentNode.removeChild(this.container), this._rafId && (cancelAnimationFrame(this._rafId), this._rafId = void 0);
  }
}
class $ {
  constructor(t, e = {}) {
    this.extensions = /* @__PURE__ */ new Map(), this.commands = /* @__PURE__ */ new Map(), this.eventListeners = /* @__PURE__ */ new Map(), this.folds = [], this.currentTheme = "default", this.isDestroyed = !1, this.undoStack = [], this.redoStack = [], this.suppressHistory = !1, this.expectingProgrammaticCursor = !1, this.config = {
      value: "",
      theme: "default",
      readOnly: !1,
      tabSize: 2,
      lineWrapping: !1,
      lineNumbers: !0,
      ...e
    }, this.textModel = new k(this.config.value), this.view = new P(t), this.setupEventHandlers(), this.config.extensions && this.config.extensions.forEach((s) => this.addExtension(s)), this.setTheme(this.config.theme), this.view.setReadOnly(this.config.readOnly || !1), this.renderTextWithHighlight(this.textModel.getText()), this.registerBuiltInCommands();
  }
  // Public accessors for extensions
  getTextModel() {
    return this.textModel;
  }
  getView() {
    return this.view;
  }
  getConfig() {
    return { ...this.config };
  }
  // Register built-in editor commands like undo/redo/insertTab
  registerBuiltInCommands() {
    this.registerCommand("undo", () => this.undo()), this.registerCommand("redo", () => this.redo()), this.registerCommand("insertTab", () => this.insertTab()), this.registerCommand("save", () => {
      this.emit("save");
    });
  }
  // Get keymap extension if available
  getKeymapExtension() {
    return this.extensions.get("keymap");
  }
  // Setup DOM event handlers
  setupEventHandlers() {
    const t = this.view.getContentElement();
    t.addEventListener("input", () => {
      const e = this.view.getText(), s = this.textModel.getText();
      if (e !== s) {
        if (!this.suppressHistory) {
          const i = this.getCursor().position, n = this.textModel.positionToOffset(i), o = this.getSelection();
          let h, r;
          o && (h = this.textModel.positionToOffset(o.start), r = this.textModel.positionToOffset(o.end)), this.undoStack.push({ text: s, cursorOffset: n, anchorOffset: h, focusOffset: r }), this.undoStack.length > 100 && this.undoStack.shift(), this.redoStack.length = 0;
        }
        this.textModel.setText(e), this.highlightTimeout && clearTimeout(this.highlightTimeout), this.highlightTimeout = setTimeout(() => {
          this.renderTextWithHighlight(this.textModel.getText(), !1), this.highlightTimeout = null;
        }, 300), this.updateLineNumbers(), this.emit("change", [{ range: this.getFullRange(), text: e, oldText: s }]);
      }
    }), t.addEventListener("selectionchange", () => {
      const e = this.getCursor(), s = this.getSelection();
      this.emit("cursor", e), s && this.emit("selection", s);
    }), t.addEventListener("keydown", (e) => {
      if (this.emit("keydown", e), e.key === "Tab") {
        this.config.readOnly || this.insertTab(), e.preventDefault(), e.stopPropagation();
        return;
      }
      if (e.key === "Enter") {
        if (!this.config.readOnly) {
          const s = window.getSelection();
          if (s && s.rangeCount > 0) {
            const i = this.getCursor().position, n = this.textModel.positionToOffset(i), o = this.getSelection();
            let h, r;
            o && (h = this.textModel.positionToOffset(o.start), r = this.textModel.positionToOffset(o.end)), this.suppressHistory || (this.undoStack.push({ text: this.textModel.getText(), cursorOffset: n, anchorOffset: h, focusOffset: r }), this.undoStack.length > 100 && this.undoStack.shift(), this.redoStack.length = 0);
            const l = s.getRangeAt(0);
            l.deleteContents();
            const c = document.createTextNode(`
`);
            l.insertNode(c), l.setStartAfter(c), l.collapse(!0), s.removeAllRanges(), s.addRange(l);
            const d = this.getCursor().position, f = this.textModel.positionToOffset(d), g = this.getSelection();
            let a, u;
            g && (a = this.textModel.positionToOffset(g.start), u = this.textModel.positionToOffset(g.end));
            const p = this.view.getText();
            this.textModel.setText(p), this.highlightTimeout && clearTimeout(this.highlightTimeout), this.highlightTimeout = setTimeout(() => {
              this.renderTextWithHighlight(this.textModel.getText(), !1), requestAnimationFrame(() => {
                try {
                  if (g && (a !== void 0 || u !== void 0)) {
                    const m = a !== void 0 ? a : f, M = u !== void 0 ? u : f, y = Math.min(m, M), C = Math.max(m, M), w = this.textModel.offsetToPosition(y), v = this.textModel.offsetToPosition(C);
                    this.setSelection({ start: w, end: v });
                  } else {
                    const m = this.textModel.offsetToPosition(f);
                    this.setCursor(m);
                  }
                } catch {
                }
              }), this.highlightTimeout = null;
            }, 300), this.updateLineNumbers(), this.emit("change", [{ range: this.getFullRange(), text: this.getValue(), oldText: "" }]);
          }
        }
        e.preventDefault(), e.stopPropagation();
        return;
      }
      for (const s of this.extensions.values())
        if (s.onKeyDown && s.onKeyDown(e) === !1) {
          e.preventDefault(), e.stopPropagation();
          return;
        }
    }), t.addEventListener("mousedown", (e) => {
      this.emit("mousedown", e);
      for (const s of this.extensions.values())
        if (s.onMouseDown && s.onMouseDown(e) === !1) {
          e.preventDefault(), e.stopPropagation();
          return;
        }
    }), t.addEventListener("focus", () => {
      this.emit("focus");
    }), t.addEventListener("blur", () => {
      this.emit("blur");
    });
  }
  // Update line numbers display
  updateLineNumbers() {
    const t = this.textModel.getLineCount();
    this.view.updateLineNumbers(t);
  }
  // Get full range of document
  getFullRange() {
    return {
      start: { line: 0, column: 0 },
      end: {
        line: this.textModel.getLineCount() - 1,
        column: this.textModel.getLine(this.textModel.getLineCount() - 1).length
      }
    };
  }
  // Emit events to listeners
  emit(t, ...e) {
    const s = this.eventListeners.get(t);
    s && s.forEach((i) => i(...e));
  }
  // State management
  getValue() {
    return this.textModel.getText();
  }
  setValue(t) {
    const e = this.textModel.getText();
    this.textModel.setText(t), this.renderTextWithHighlight(t, !1), this.updateLineNumbers(), this.emit("change", [{ range: this.getFullRange(), text: t, oldText: e }]);
  }
  getState() {
    return {
      text: this.getValue(),
      cursor: this.getCursor(),
      selection: this.getSelection(),
      readOnly: this.config.readOnly || !1,
      theme: this.currentTheme
    };
  }
  // Cursor & Selection
  getCursor() {
    const t = this.view.getCursorPosition();
    return {
      position: t,
      anchor: t
      // For now, cursor and anchor are the same
    };
  }
  setCursor(t) {
    this.view.setCursorPosition(t), this.emit("cursor", this.getCursor());
  }
  getSelection() {
    return this.view.getSelectionRange();
  }
  setSelection(t) {
    this.view.setSelectionRange(t), this.emit("selection", t);
  }
  // Configuration
  setTheme(t) {
    this.currentTheme = t;
    const e = {
      "editor-background": t === "dark" ? "#1e1e1e" : "#ffffff",
      "editor-foreground": t === "dark" ? "#f8f9fa" : "#1a1a1a",
      "editor-gutter-background": t === "dark" ? "#252526" : "#f8f9fa",
      "editor-gutter-foreground": t === "dark" ? "#858585" : "#666666",
      "editor-gutter-border": t === "dark" ? "#3e3e42" : "#e1e5e9"
    };
    this.view.applyTheme(e);
    const s = this.extensions.get("syntax-highlighting");
    if (s && typeof s.setTheme == "function")
      try {
        s.setTheme(t === "dark" ? "dark" : "light"), this.renderTextWithHighlight(this.textModel.getText());
      } catch (i) {
        console.warn("Error applying theme to syntax-highlighting extension", i);
      }
  }
  setReadOnly(t) {
    this.config.readOnly = t, this.view.setReadOnly(t);
  }
  // Extensions & Commands
  addExtension(t) {
    if (this.extensions.has(t.name))
      throw new Error(`Extension '${t.name}' already exists`);
    this.extensions.set(t.name, t), t.setup(this), t.name === "syntax-highlighting" && typeof t.highlightHTML == "function" && this.renderTextWithHighlight(this.textModel.getText());
  }
  removeExtension(t) {
    const e = this.extensions.get(t);
    e && e.destroy && e.destroy(), this.extensions.delete(t);
  }
  executeCommand(t, ...e) {
    const s = this.commands.get(t);
    s ? s(this, ...e) : console.warn(`Command '${t}' not found`);
  }
  // Register a command
  registerCommand(t, e) {
    this.commands.set(t, e);
  }
  // Search & Navigation
  search(t, e = {}) {
    const s = {
      caseSensitive: !1,
      regex: !1,
      ...e
    }, i = [], n = this.getValue();
    n.split(`
`);
    let o = s.caseSensitive ? n : n.toLowerCase(), h = s.caseSensitive ? t : t.toLowerCase();
    if (s.regex) {
      const r = new RegExp(h, s.caseSensitive ? "g" : "gi");
      let l;
      for (; (l = r.exec(o)) !== null; ) {
        const c = this.textModel.offsetToPosition(l.index), d = this.textModel.offsetToPosition(l.index + l[0].length);
        i.push({
          range: { start: c, end: d },
          match: l[0]
        });
      }
    } else {
      let r = 0, l = o.indexOf(h, r);
      for (; l !== -1; ) {
        const c = l + t.length, d = this.textModel.offsetToPosition(l), f = this.textModel.offsetToPosition(c);
        i.push({
          range: { start: d, end: f },
          match: n.substring(l, c)
        }), r = c, l = o.indexOf(h, r);
      }
    }
    return i;
  }
  replace(t, e) {
    const s = this.getValue();
    if (!this.suppressHistory) {
      const n = this.getCursor().position, o = this.textModel.positionToOffset(n), h = this.getSelection();
      let r, l;
      h && (r = this.textModel.positionToOffset(h.start), l = this.textModel.positionToOffset(h.end)), this.undoStack.push({ text: s, cursorOffset: o, anchorOffset: r, focusOffset: l }), this.undoStack.length > 100 && this.undoStack.shift(), this.redoStack.length = 0;
    }
    const i = this.textModel.replaceRange(t, e);
    this.renderTextWithHighlight(this.getValue(), !1), this.emit("change", [i]);
  }
  replaceAll(t, e, s = {}) {
    const i = this.search(t, s);
    let n = 0;
    for (let o = i.length - 1; o >= 0; o--)
      this.replace(i[o].range, e), n++;
    return n;
  }
  // Folding (basic implementation)
  fold(t) {
    const e = {
      start: t.start,
      end: t.end,
      collapsed: !0,
      level: 0
    };
    this.folds.push(e);
  }
  unfold(t) {
    this.folds = this.folds.filter(
      (e) => !(e.start.line === t.start.line && e.end.line === t.end.line)
    );
  }
  getFolds() {
    return [...this.folds];
  }
  // Utilities
  focus() {
    this.view.focus();
  }
  blur() {
    this.view.blur();
  }
  // Render text using syntax highlighting extension if available
  // If `restoreSelection` is true (default), the method captures current selection/caret
  // and restores it after updating the DOM. Callers that will explicitly set the caret
  // should pass `false` to avoid stomping programmatic cursor changes.
  renderTextWithHighlight(t, e = !0) {
    const s = this.extensions.get("syntax-highlighting");
    if (s && typeof s.highlightHTML == "function")
      try {
        const i = !e && !this.expectingProgrammaticCursor;
        let n, o, h, r;
        if (e || i) {
          n = this.getSelection();
          const c = this.getCursor().position;
          o = this.textModel.positionToOffset(c), n && (h = this.textModel.positionToOffset(n.start), r = this.textModel.positionToOffset(n.end));
        }
        const l = s.highlightHTML(t);
        typeof this.view.setHighlightHTML == "function" ? this.view.setHighlightHTML(l) : this.view.setHTML(l), (e || i) && requestAnimationFrame(() => {
          try {
            if (n && (h !== void 0 || r !== void 0)) {
              const c = h !== void 0 ? h : o, d = r !== void 0 ? r : o, f = Math.min(c, d), g = Math.max(c, d), a = this.textModel.offsetToPosition(f), u = this.textModel.offsetToPosition(g);
              this.view.setSelectionRange({ start: a, end: u });
            } else if (o !== void 0) {
              const c = this.textModel.offsetToPosition(o);
              this.view.setCursorPosition(c);
            }
          } catch {
          }
        });
        return;
      } catch (i) {
        console.warn("Syntax highlighting failed, falling back to plain text", i);
      }
    this.view.setText(t);
  }
  destroy() {
    if (!this.isDestroyed) {
      this.isDestroyed = !0;
      for (const t of this.extensions.values())
        t.destroy && t.destroy();
      this.extensions.clear(), this.view.destroy(), this.commands.clear(), this.eventListeners.clear();
    }
  }
  // History: undo/redo
  undo() {
    if (this.undoStack.length === 0) return;
    const t = this.undoStack.pop(), e = { text: this.getValue(), cursorOffset: this.textModel.positionToOffset(this.getCursor().position) };
    this.redoStack.push(e);
    try {
      this.suppressHistory = !0, this.expectingProgrammaticCursor = !0;
      let s, i;
      typeof t == "string" ? s = t : (s = t.text, i = t.cursorOffset), this.setValue(s), requestAnimationFrame(() => {
        try {
          if (i != null)
            if (typeof t != "string" && (t.anchorOffset !== void 0 || t.focusOffset !== void 0)) {
              const n = t.anchorOffset !== void 0 ? t.anchorOffset : i, o = t.focusOffset !== void 0 ? t.focusOffset : i, h = Math.min(n, o), r = Math.max(n, o), l = this.textModel.offsetToPosition(h), c = this.textModel.offsetToPosition(r);
              this.setSelection({ start: l, end: c });
            } else {
              const n = this.textModel.offsetToPosition(i);
              this.setCursor(n);
            }
        } catch {
        }
      }), setTimeout(() => {
        this.expectingProgrammaticCursor = !1;
      }, 30);
    } finally {
      this.suppressHistory = !1;
    }
  }
  redo() {
    if (this.redoStack.length === 0) return;
    const t = this.redoStack.pop(), e = { text: this.getValue(), cursorOffset: this.textModel.positionToOffset(this.getCursor().position) };
    this.undoStack.push(e);
    try {
      this.suppressHistory = !0, this.expectingProgrammaticCursor = !0;
      let s, i;
      typeof t == "string" ? s = t : (s = t.text, i = t.cursorOffset), this.setValue(s), requestAnimationFrame(() => {
        try {
          if (i != null)
            if (typeof t != "string" && (t.anchorOffset !== void 0 || t.focusOffset !== void 0)) {
              const n = t.anchorOffset !== void 0 ? t.anchorOffset : i, o = t.focusOffset !== void 0 ? t.focusOffset : i, h = Math.min(n, o), r = Math.max(n, o), l = this.textModel.offsetToPosition(h), c = this.textModel.offsetToPosition(r);
              this.setSelection({ start: l, end: c });
            } else {
              const n = this.textModel.offsetToPosition(i);
              this.setCursor(n);
            }
        } catch {
        }
      }), setTimeout(() => {
        this.expectingProgrammaticCursor = !1;
      }, 30);
    } finally {
      this.suppressHistory = !1;
    }
  }
  // Insert a tab character or spaces at current cursor
  insertTab() {
    if (this.config.readOnly) return;
    const t = this.getCursor().position, e = this.textModel.positionToOffset(t), s = " ".repeat(this.config.tabSize || 2), i = this.textModel.insertText(t, s), n = this.textModel.offsetToPosition(this.textModel.positionToOffset(t) + s.length);
    if (!this.suppressHistory) {
      const o = this.getSelection();
      let h, r;
      o && (h = this.textModel.positionToOffset(o.start), r = this.textModel.positionToOffset(o.end)), this.undoStack.push({ text: this.getValue(), cursorOffset: e, anchorOffset: h, focusOffset: r }), this.redoStack.length = 0;
    }
    this.expectingProgrammaticCursor = !0, this.renderTextWithHighlight(this.getValue(), !1), this.setCursor(n), setTimeout(() => {
      this.expectingProgrammaticCursor = !1;
    }, 20), this.emit("change", [i]);
  }
  // Insert a newline at current cursor position
  insertNewLine() {
    if (this.config.readOnly) return;
    const t = this.getCursor().position, e = this.textModel.positionToOffset(t), s = this.textModel.insertText(t, `
`), i = this.textModel.offsetToPosition(this.textModel.positionToOffset(t) + 1);
    if (!this.suppressHistory) {
      const n = this.getSelection();
      let o, h;
      n && (o = this.textModel.positionToOffset(n.start), h = this.textModel.positionToOffset(n.end)), this.undoStack.push({ text: this.getValue(), cursorOffset: e, anchorOffset: o, focusOffset: h }), this.redoStack.length = 0;
    }
    this.expectingProgrammaticCursor = !0, this.renderTextWithHighlight(this.getValue(), !1), this.setCursor(i), setTimeout(() => {
      this.expectingProgrammaticCursor = !1;
    }, 20), this.emit("change", [s]);
  }
  // Events
  on(t, e) {
    this.eventListeners.has(t) || this.eventListeners.set(t, []), this.eventListeners.get(t).push(e);
  }
  off(t, e) {
    if (!this.eventListeners.has(t)) return;
    const s = this.eventListeners.get(t);
    if (e) {
      const i = s.indexOf(e);
      i !== -1 && s.splice(i, 1);
    } else
      s.length = 0;
  }
}
class H {
  constructor(t) {
    this.name = "keymap", this.editor = null, this.keymap = {}, this.isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0, this.keymap = t || this.getDefaultKeymap();
  }
  setup(t) {
    this.editor = t;
  }
  handleKeyDown(t) {
    if (!this.editor) return;
    const e = this.findMatchingBinding(t);
    if (e)
      return this.editor.executeCommand(e.command), t.preventDefault(), t.stopPropagation(), !1;
  }
  findMatchingBinding(t) {
    const { key: e, ctrlKey: s, altKey: i, shiftKey: n, metaKey: o } = t, h = String(e).toLowerCase(), r = this.keymap[h];
    if (!r) return null;
    for (const l of r) {
      const c = l.ctrlKey === void 0 || l.ctrlKey === s, d = l.altKey === void 0 || l.altKey === i, f = l.shiftKey === void 0 || l.shiftKey === n, g = l.metaKey === void 0 || l.metaKey === o;
      if (c && d && f && g)
        return l;
    }
    return null;
  }
  // Allow EditorCore to call this directly when checking extension.onKeyDown
  onKeyDown(t) {
    return this.handleKeyDown(t);
  }
  getDefaultKeymap() {
    const t = {};
    return this.addBinding(t, "f", { ctrlKey: !this.isMac, metaKey: this.isMac }, "find"), this.addBinding(t, "h", { ctrlKey: !this.isMac, metaKey: this.isMac }, "replace"), this.addBinding(t, "f3", {}, "findNext"), this.addBinding(t, "f3", { shiftKey: !0 }, "findPrev"), this.addBinding(t, "g", { ctrlKey: !this.isMac, metaKey: this.isMac }, "findNext"), this.addBinding(t, "[", { ctrlKey: !this.isMac, metaKey: this.isMac, shiftKey: !0 }, "fold"), this.addBinding(t, "]", { ctrlKey: !this.isMac, metaKey: this.isMac, shiftKey: !0 }, "unfold"), this.addBinding(t, "s", { ctrlKey: !0 }, "save"), this.addBinding(t, "s", { metaKey: !0 }, "save"), this.addBinding(t, "z", { ctrlKey: !0 }, "undo"), this.addBinding(t, "z", { metaKey: !0 }, "undo"), this.addBinding(t, "y", { ctrlKey: !0 }, "redo"), this.addBinding(t, "y", { metaKey: !0 }, "redo"), this.addBinding(t, "z", { ctrlKey: !0, shiftKey: !0 }, "redo"), this.addBinding(t, "z", { metaKey: !0, shiftKey: !0 }, "redo"), this.addBinding(t, "tab", {}, "insertTab"), this.addBinding(t, "t", { ctrlKey: !this.isMac, metaKey: this.isMac, shiftKey: !0 }, "toggleTheme"), t;
  }
  addBinding(t, e, s, i) {
    const n = e.toLowerCase();
    t[n] || (t[n] = []), t[n].push({
      key: n,
      command: i,
      ...s
    });
  }
  // Public API for customizing keymap
  setKeymap(t) {
    this.keymap = { ...t };
  }
  addKeyBinding(t) {
    const e = t.key.toLowerCase();
    this.keymap[e] || (this.keymap[e] = []), this.keymap[e] = this.keymap[e].filter((s) => s.command !== t.command), this.keymap[e].push({
      ...t,
      key: e
    });
  }
  removeKeyBinding(t, e) {
    const s = t.toLowerCase();
    e ? this.keymap[s] && (this.keymap[s] = this.keymap[s].filter((i) => i.command !== e), this.keymap[s].length === 0 && delete this.keymap[s]) : delete this.keymap[s];
  }
  getKeymap() {
    return { ...this.keymap };
  }
  getBindingsForCommand(t) {
    const e = [];
    for (const s in this.keymap)
      for (const i of this.keymap[s])
        i.command === t && e.push({ ...i });
    return e;
  }
  getPlatformInfo() {
    return {
      isMac: this.isMac,
      platform: navigator.platform
    };
  }
  destroy() {
    this.keymap = {}, this.editor = null;
  }
}
class R {
  constructor() {
    this.name = "transaction", this.transactions = [];
  }
  setup(t) {
    t.on("change", (e) => {
      const s = {
        changes: [e],
        selection: t.getSelection(),
        effects: [],
        annotations: []
      };
      this.transactions.push(s);
    });
  }
  getTransactions() {
    return this.transactions;
  }
  destroy() {
    this.transactions = [];
  }
}
class N {
  constructor() {
    this.name = "line-numbers", this.editor = null, this.lineNumbersElement = null, this.isEnabled = !0;
  }
  setup(t) {
    this.editor = t, this.createLineNumbers(), t.registerCommand("toggleLineNumbers", () => {
      this.toggle();
    }), t.on("change", () => {
      this.updateLineNumbers();
    }), this.updateLineNumbers();
  }
  createLineNumbers() {
    if (!this.editor) return;
    const e = this.editor.getView().getLineNumbersElement();
    e && (this.lineNumbersElement = e);
  }
  updateLineNumbers() {
    if (!this.lineNumbersElement || !this.editor || !this.isEnabled) return;
    const t = this.editor.getValue().split(`
`).length, e = Array.from({ length: Math.max(t, 20) }, (s, i) => i + 1);
    this.lineNumbersElement.innerHTML = e.map((s) => `<div style="height: 21px; line-height: 21px; padding-right: 12px;">${s}</div>`).join("");
  }
  toggle() {
    this.isEnabled = !this.isEnabled, this.lineNumbersElement && (this.lineNumbersElement.style.display = this.isEnabled ? "block" : "none");
    const t = this.editor.getView().getContentElement();
    t && (t.style.marginLeft = this.isEnabled ? "60px" : "0"), this.updateLineNumbers();
  }
  destroy() {
    this.lineNumbersElement = null, this.editor = null;
  }
}
class K {
  constructor() {
    this.name = "theme", this.editor = null, this.currentTheme = "dark";
  }
  setup(t) {
    this.editor = t, t.registerCommand("setTheme", (e) => {
      this.setTheme(e);
    }), t.registerCommand("toggleTheme", () => {
      this.toggleTheme();
    }), this.setTheme(this.currentTheme);
  }
  setTheme(t) {
    this.editor && (this.currentTheme = t, this.editor.setTheme(t));
  }
  toggleTheme() {
    const t = this.currentTheme === "dark" ? "light" : "dark";
    this.setTheme(t);
  }
  getCurrentTheme() {
    return this.currentTheme;
  }
  destroy() {
    this.editor = null;
  }
}
class B {
  constructor() {
    this.name = "read-only", this.editor = null, this.isReadOnly = !1;
  }
  setup(t) {
    this.editor = t, t.registerCommand("setReadOnly", (e) => {
      this.setReadOnly(e);
    }), t.registerCommand("toggleReadOnly", () => {
      this.toggleReadOnly();
    }), t.on("keydown", (e) => {
      if (e.ctrlKey && e.key === "r")
        return e.preventDefault(), this.toggleReadOnly(), !1;
    });
  }
  setReadOnly(t) {
    this.editor && (this.isReadOnly = t, this.editor.setReadOnly(t));
  }
  toggleReadOnly() {
    this.setReadOnly(!this.isReadOnly);
  }
  isCurrentlyReadOnly() {
    return this.isReadOnly;
  }
  destroy() {
    this.editor = null;
  }
}
class V {
  constructor() {
    this.name = "search", this.editor = null, this.searchUI = null, this.isVisible = !1, this.currentResults = [], this.currentIndex = -1;
  }
  setup(t) {
    this.editor = t, t.registerCommand("find", () => {
      this.showSearch();
    }), t.registerCommand("findNext", () => {
      this.findNext();
    }), t.registerCommand("findPrev", () => {
      this.findPrev();
    }), t.registerCommand("replace", () => {
      this.showReplace();
    }), t.registerCommand("replaceAll", (e, s) => {
      this.replaceAll(e, s);
    });
  }
  showSearch() {
    if (this.editor && (this.searchUI || this.createSearchUI(), this.isVisible = !0, this.searchUI)) {
      this.searchUI.style.display = "block";
      const t = this.searchUI.querySelector("input");
      t && (t.focus(), t.select());
    }
  }
  showReplace() {
    this.showSearch();
    const t = this.searchUI?.querySelector(".search-replace-input");
    t && (t.style.display = "block", t.focus());
    const e = this.searchUI?.querySelector(".search-status");
    e && (e.textContent = "Replace mode - Enter to replace, Shift+Enter to replace all");
  }
  hideSearch() {
    this.isVisible = !1, this.searchUI && (this.searchUI.style.display = "none"), this.clearHighlights();
  }
  createSearchUI() {
    if (!this.editor) return;
    const t = document.querySelector(".rte-source-editor-modal");
    if (!t) return;
    this.searchUI = document.createElement("div"), this.searchUI.style.cssText = `
      position: absolute;
      top: 10px;
      right: 10px;
      background: var(--editor-background, #1e1e1e);
      border: 1px solid var(--editor-gutter-border, #3e3e42);
      border-radius: 4px;
      padding: 8px;
      z-index: 1000;
      display: none;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      min-width: 250px;
    `, this.searchUI.innerHTML = `
      <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 4px;">
        <input type="text" placeholder="Find..." style="
          flex: 1;
          padding: 4px 8px;
          background: var(--editor-gutter-background, #252526);
          color: var(--editor-foreground, #f8f9fa);
          border: 1px solid var(--editor-gutter-border, #3e3e42);
          border-radius: 3px;
          font-size: 12px;
          outline: none;
        " />
        <button class="search-prev" style="
          padding: 2px 6px;
          background: var(--editor-gutter-background, #252526);
          color: var(--editor-gutter-foreground, #858585);
          border: 1px solid var(--editor-gutter-border, #3e3e42);
          border-radius: 3px;
          cursor: pointer;
          font-size: 11px;
        ">↑</button>
        <button class="search-next" style="
          padding: 2px 6px;
          background: var(--editor-gutter-background, #252526);
          color: var(--editor-gutter-foreground, #858585);
          border: 1px solid var(--editor-gutter-border, #3e3e42);
          border-radius: 3px;
          cursor: pointer;
          font-size: 11px;
        ">↓</button>
        <button class="search-close" style="
          padding: 2px 6px;
          background: var(--editor-gutter-background, #252526);
          color: var(--editor-gutter-foreground, #858585);
          border: 1px solid var(--editor-gutter-border, #3e3e42);
          border-radius: 3px;
          cursor: pointer;
          font-size: 11px;
        ">×</button>
      </div>
      <div class="search-status" style="
        font-size: 11px;
        color: var(--editor-gutter-foreground, #858585);
        text-align: center;
      "></div>
      <input type="text" class="search-replace-input" placeholder="Replace with..." style="
        width: 100%;
        padding: 4px 8px;
        background: var(--editor-gutter-background, #252526);
        color: var(--editor-foreground, #f8f9fa);
        border: 1px solid var(--editor-gutter-border, #3e3e42);
        border-radius: 3px;
        font-size: 12px;
        outline: none;
        display: none;
        margin-top: 4px;
      " />
    `;
    const e = this.searchUI.querySelector("input"), s = this.searchUI.querySelector(".search-replace-input"), i = this.searchUI.querySelector(".search-prev"), n = this.searchUI.querySelector(".search-next"), o = this.searchUI.querySelector(".search-close");
    e.addEventListener("input", () => {
      this.performSearch(e.value);
    }), e.addEventListener("keydown", (h) => {
      h.key === "Enter" && (h.preventDefault(), h.shiftKey ? this.findPrev() : this.findNext());
    }), s.addEventListener("keydown", (h) => {
      h.key === "Enter" && (h.preventDefault(), h.shiftKey ? this.replaceAll(e.value, s.value) : this.replaceCurrent(e.value, s.value));
    }), i.addEventListener("click", () => this.findPrev()), n.addEventListener("click", () => this.findNext()), o.addEventListener("click", () => this.hideSearch()), t.appendChild(this.searchUI);
  }
  performSearch(t) {
    if (!this.editor || !t.trim()) {
      this.clearHighlights(), this.updateStatus("");
      return;
    }
    const e = this.editor.getValue(), s = [];
    let i = e.toLowerCase().indexOf(t.toLowerCase());
    for (; i !== -1; ) {
      const n = this.getPositionFromOffset(e, i), o = this.getPositionFromOffset(e, i + t.length);
      s.push({
        range: { start: n, end: o },
        match: e.substring(i, i + t.length)
      }), i = e.toLowerCase().indexOf(t.toLowerCase(), i + 1);
    }
    this.currentResults = s, this.currentIndex = this.currentResults.length > 0 ? 0 : -1, this.updateHighlights(), this.updateStatus(`${this.currentResults.length} matches`);
  }
  getPositionFromOffset(t, e) {
    const s = t.substring(0, e).split(`
`), i = s.length - 1, n = s[s.length - 1].length;
    return { line: i, column: n };
  }
  findNext() {
    this.currentResults.length !== 0 && (this.currentIndex = (this.currentIndex + 1) % this.currentResults.length, this.updateHighlights());
  }
  findPrev() {
    this.currentResults.length !== 0 && (this.currentIndex = this.currentIndex <= 0 ? this.currentResults.length - 1 : this.currentIndex - 1, this.updateHighlights());
  }
  replaceCurrent(t, e) {
    if (!this.editor || !t.trim() || this.currentIndex === -1) return;
    const s = this.currentResults[this.currentIndex];
    if (!s) return;
    const i = this.editor.getValue(), n = this.getOffsetFromPosition(i, s.range.start), o = i.substring(0, n), h = i.substring(n + t.length), r = o + e + h;
    this.editor.setValue(r), this.performSearch(t), this.updateStatus("Replaced current occurrence");
  }
  replaceAll(t, e) {
    if (!this.editor || !t.trim()) return;
    let s = this.editor.getValue(), i = 0, n = s.toLowerCase().indexOf(t.toLowerCase());
    for (; n !== -1; )
      s = s.substring(0, n) + e + s.substring(n + t.length), i++, n = s.toLowerCase().indexOf(t.toLowerCase(), n + e.length);
    i > 0 && (this.editor.setValue(s), this.updateStatus(`Replaced ${i} occurrences`));
  }
  getOffsetFromPosition(t, e) {
    const s = t.split(`
`);
    let i = 0;
    for (let n = 0; n < e.line; n++)
      i += s[n].length + 1;
    return i += e.column, i;
  }
  updateHighlights() {
    this.clearHighlights(), !(this.currentResults.length === 0 || this.currentIndex === -1) && (this.currentResults[this.currentIndex], this.updateStatus(`${this.currentResults.length} matches (showing ${this.currentIndex + 1}/${this.currentResults.length})`));
  }
  clearHighlights() {
  }
  updateStatus(t) {
    const e = this.searchUI?.querySelector(".search-status");
    e && (e.textContent = t);
  }
  destroy() {
    this.searchUI && this.searchUI.parentNode && this.searchUI.parentNode.removeChild(this.searchUI), this.searchUI = null, this.editor = null;
  }
}
class A {
  constructor() {
    this.name = "bracket-matching", this.editor = null, this.bracketPairs = {
      "(": ")",
      "[": "]",
      "{": "}",
      "<": ">"
    }, this.reverseBracketPairs = {
      ")": "(",
      "]": "[",
      "}": "{",
      ">": "<"
    }, this.currentMatch = null;
  }
  setup(t) {
    this.editor = t, t.on("cursor", () => {
      this.updateBracketMatching();
    }), t.on("change", () => {
      this.updateBracketMatching();
    });
  }
  updateBracketMatching() {
    if (!this.editor) return;
    const t = this.editor.getCursor(), e = this.editor.getValue();
    this.clearBracketHighlighting();
    const s = this.getBracketAtPosition(e, t.position);
    if (!s) return;
    const i = this.findMatchingBracket(e, s);
    i && (this.currentMatch = i, this.highlightBrackets(i));
  }
  getBracketAtPosition(t, e) {
    const s = t.split(`
`);
    if (e.line >= s.length) return null;
    const i = s[e.line];
    if (e.column >= i.length) return null;
    const n = i[e.column];
    return this.bracketPairs[n] || this.reverseBracketPairs[n] ? { char: n, position: e } : null;
  }
  findMatchingBracket(t, e) {
    const s = t.split(`
`), i = e.position.line, n = e.position.column, o = e.char;
    return this.bracketPairs[o] ? this.findClosingBracket(t, s, i, n, o) : this.reverseBracketPairs[o] ? this.findOpeningBracket(t, s, i, n, o) : null;
  }
  findClosingBracket(t, e, s, i, n) {
    const o = this.bracketPairs[n];
    let h = 0;
    for (let r = s; r < e.length; r++) {
      const l = e[r], c = r === s ? i : 0;
      for (let d = c; d < l.length; d++) {
        const f = l[d];
        if (f === n)
          h++;
        else if (f === o && (h--, h === 0))
          return {
            open: { start: { line: s, column: i }, end: { line: s, column: i + 1 } },
            close: { start: { line: r, column: d }, end: { line: r, column: d + 1 } },
            type: n
          };
      }
    }
    return null;
  }
  findOpeningBracket(t, e, s, i, n) {
    const o = this.reverseBracketPairs[n];
    let h = 0;
    for (let r = s; r >= 0; r--) {
      const l = e[r], c = r === s ? i : l.length - 1;
      for (let d = c; d >= 0; d--) {
        const f = l[d];
        if (f === n)
          h++;
        else if (f === o && (h--, h === 0))
          return {
            open: { start: { line: r, column: d }, end: { line: r, column: d + 1 } },
            close: { start: { line: s, column: i }, end: { line: s, column: i + 1 } },
            type: o
          };
      }
    }
    return null;
  }
  highlightBrackets(t) {
  }
  clearBracketHighlighting() {
    this.currentMatch = null;
  }
  getCurrentMatch() {
    return this.currentMatch;
  }
  destroy() {
    this.clearBracketHighlighting(), this.editor = null;
  }
}
class U {
  constructor() {
    this.name = "code-folding", this.editor = null, this.foldIndicators = [], this.foldingUI = null;
  }
  setup(t) {
    this.editor = t, t.registerCommand("fold", () => {
      this.foldAtCursor();
    }), t.registerCommand("unfold", () => {
      this.unfoldAtCursor();
    }), t.registerCommand("foldAll", () => {
      this.foldAll();
    }), t.registerCommand("unfoldAll", () => {
      this.unfoldAll();
    }), t.on("change", () => {
      this.updateFoldIndicators();
    }), this.createFoldingUI(), this.updateFoldIndicators();
  }
  createFoldingUI() {
    if (!this.editor) return;
    const t = document.querySelector(".rte-source-editor-modal");
    t && (this.foldingUI = document.createElement("div"), this.foldingUI.style.cssText = `
      position: absolute;
      left: 40px;
      top: 0;
      bottom: 0;
      width: 20px;
      pointer-events: none;
      z-index: 2;
    `, t.appendChild(this.foldingUI));
  }
  updateFoldIndicators() {
    if (!this.editor || !this.foldingUI) return;
    this.foldingUI.innerHTML = "", this.foldIndicators = [];
    const e = this.editor.getValue().split(`
`);
    this.findFoldableLines(e).forEach((i) => {
      this.createFoldIndicator(i);
    });
  }
  findFoldableLines(t) {
    const e = [];
    for (let s = 0; s < t.length; s++) {
      const i = t[s].trim();
      (i.startsWith("{") || i.startsWith("function") || i.startsWith("class") || i.startsWith("if") || i.includes("=>") || i.startsWith("for") || i.startsWith("while") || i.startsWith("try")) && e.push(s);
    }
    return e;
  }
  createFoldIndicator(t) {
    if (!this.foldingUI) return;
    const e = document.createElement("div");
    e.style.cssText = `
      position: absolute;
      left: 0;
      top: ${t * 21}px;
      width: 20px;
      height: 21px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      pointer-events: auto;
      color: var(--editor-gutter-foreground, #858585);
      font-size: 10px;
      user-select: none;
    `, e.innerHTML = "▶", e.title = "Code folding not yet implemented - click shows fold indicators", e.addEventListener("click", () => {
    }), this.foldingUI.appendChild(e), this.foldIndicators.push(e);
  }
  foldAtCursor() {
  }
  unfoldAtCursor() {
  }
  foldAll() {
  }
  unfoldAll() {
  }
  destroy() {
    this.foldingUI && this.foldingUI.parentNode && this.foldingUI.parentNode.removeChild(this.foldingUI), this.foldingUI = null, this.foldIndicators = [], this.editor = null;
  }
}
class F {
  constructor() {
    this.name = "syntax-highlighting", this.editor = null, this.currentTheme = "dark", this.currentLanguage = null, this.modes = /* @__PURE__ */ new Map();
  }
  setup(t) {
    this.editor = t, this.registerMode("html", { name: "html", highlight: (e, s) => this._highlightHTML(e, s) }), this.registerMode("javascript", { name: "javascript", highlight: (e, s) => this._highlightJS(e, s) }), this.registerMode("typescript", { name: "typescript", highlight: (e, s) => this._highlightJS(e, s) }), this.registerMode("php", { name: "php", highlight: (e, s) => this._highlightPHP(e, s) });
  }
  // Extension provides methods that can be called by the editor
  setTheme(t) {
    this.currentTheme = t;
  }
  setLanguage(t) {
    this.currentLanguage = t;
  }
  registerMode(t, e) {
    this.modes.set(t.toLowerCase(), e);
  }
  // Method to get syntax highlighting colors for a given theme
  getSyntaxColors() {
    return this.currentTheme === "dark" ? {
      tag: "#569cd6",
      // Blue
      comment: "#6a9955",
      // Green
      attrName: "#9cdcfe",
      // Light blue for attribute names
      attrValue: "#ce9178",
      // Orange for attribute values
      styleProp: "#c586c0",
      // Purple for CSS property names
      styleVal: "#dcdcaa",
      // Yellow-ish for CSS values
      doctype: "#808080",
      // Gray for doctype
      text: "#d4d4d4",
      // Light gray for normal text
      keyword: "#c586c0",
      // JS/PHP keywords (purple)
      string: "#ce9178",
      // JS strings
      number: "#b5cea8",
      // numbers
      variable: "#9cdcfe"
      // php variable color
    } : {
      tag: "#0000ff",
      // Blue
      comment: "#008000",
      // Green
      attrName: "#001080",
      attrValue: "#a31515",
      // Red
      styleProp: "#6a00a8",
      styleVal: "#804000",
      doctype: "#444444",
      text: "#000000",
      // Black
      keyword: "#000080",
      string: "#a31515",
      number: "#0086b3",
      variable: "#001080"
    };
  }
  // Public API: highlight a source string using the chosen mode (or detect html)
  highlight(t, e) {
    const s = this.getSyntaxColors(), i = (e || this.currentLanguage || "html").toLowerCase();
    return (this.modes.get(i) || this.modes.get("html")).highlight(t, s);
  }
  // Backwards-compatible method
  highlightHTML(t) {
    return this.highlight(t, "html");
  }
  // --- Internal mode implementations ---
  escapeHTML(t) {
    return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/'/g, "&#39;");
  }
  // Robustly unescape common HTML entities, repeating a few times to handle nested encoding like &amp;amp;...
  unescapeEntitiesRepeated(t) {
    let e = t || "";
    for (let s = 0; s < 5; s++) {
      const i = e;
      if (e = e.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'"), e === i) break;
    }
    return e;
  }
  _highlightHTML(t, e) {
    const s = e, i = (l) => this.escapeHTML(l);
    let n = i(t);
    const o = (l) => {
      let c = l.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
      return c = c.replace(/(\/\*[\s\S]*?\*\/)/g, `<span style="color: ${s.comment};">$1</span>`), c = c.replace(/([a-zA-Z-]+)(\s*:\s*)([^;{]+)(;?)/g, (d, f, g, a, u) => {
        const p = String(a).trim(), m = i(p);
        return `<span style="color: ${s.styleProp};">${f}</span>${g}<span style="color: ${s.styleVal};">${m}</span>${u}`;
      }), c;
    }, h = [];
    try {
      t.replace(/<script\b([^>]*)>([\s\S]*?)<\/script>/gi, (l, c, d) => (h.push({ attrs: String(c || ""), inner: String(d || "") }), l));
    } catch {
    }
    let r = 0;
    return n = n.replace(/(&lt;script\b([^&>]*)&gt;)([\s\S]*?)(&lt;\/script&gt;)/gi, (l, c, d, f, g) => {
      const a = h[r++]?.inner ?? this.unescapeEntitiesRepeated(f || "");
      (h[r - 1]?.attrs || d || "").toLowerCase();
      const u = this._highlightJS(a, s);
      return `${c}${u}${g}`;
    }), n = n.replace(/(&lt;style\b[^&]*&gt;)([\s\S]*?)(&lt;\/style&gt;)/gi, (l, c, d, f) => {
      const g = o(d);
      return `${c}${g}${f}`;
    }), n = n.replace(/(&lt;!--[\s\S]*?--&gt;)/g, `<span style="color: ${s.comment};">$1</span>`), n = n.replace(/(&lt;!DOCTYPE[\s\S]*?&gt;)/i, `<span style="color: ${s.doctype};">$1</span>`), n = n.replace(/(&lt;\/?\s*)([^\s&>\/]+)([\s\S]*?)(\/?&gt;)/g, (l, c, d, f, g) => {
      const a = `<span style="color: ${s.tag};">${d}</span>`;
      let u = f;
      return u = u.replace(/([\w:-]+)(\s*=\s*)((&quot;[\s\S]*?&quot;|&#39;[\s\S]*?&#39;|[^\s&>]+))/g, (p, m, M, y) => {
        const C = String(m).toLowerCase(), w = `<span style="color: ${s.attrName};">${m}</span>`;
        let v = y, T = "";
        y.startsWith("&quot;") && y.endsWith("&quot;") ? (v = y.slice(6, -6), T = "&quot;") : y.startsWith("&#39;") && y.endsWith("&#39;") && (v = y.slice(5, -5), T = "&#39;");
        let b = y;
        if (C === "style") {
          const L = v.replace(/([\w-]+)\s*:\s*([^;]+)(;?)/g, (I, S, O, E) => `<span style="color: ${s.styleProp};">${S}</span>:<span style="color: ${s.styleVal};">${O.trim()}</span>${E}`);
          T ? b = `${T}${L}${T}` : b = L, b = `<span style="color: ${s.attrValue};">${b}</span>`;
        } else
          T && (b = `${T}${v}${T}`), b = `<span style="color: ${s.attrValue};">${b}</span>`;
        return `${w}${M}${b}`;
      }), `${c}${a}${u}${g}`;
    }), n;
  }
  _highlightJS(t, e) {
    const s = this.unescapeEntitiesRepeated(t);
    this.escapeHTML(s);
    const i = [], n = (g) => {
      let a = "", u = g;
      do
        a = String.fromCharCode(97 + u % 26) + a, u = Math.floor(u / 26) - 1;
      while (u >= 0);
      return a || "a";
    }, o = (g) => `\0${n(g)}\0`, h = (g) => {
      const a = i.length;
      return i.push(g), o(a);
    };
    let r;
    const l = /(\/\*[\s\S]*?\*\/)|(\/\/[^\n\r]*)|("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`)/g;
    let c = 0, d = "";
    for (; r = l.exec(s); ) {
      const g = r.index;
      c < g && (d += this.escapeHTML(s.slice(c, g)));
      const a = r[0];
      /^\/\*/.test(a) || /^\/\//.test(a) ? d += h(`<span style="color: ${e.comment};">${this.escapeHTML(a)}</span>`) : d += h(`<span style="color: ${e.string};">${this.escapeHTML(a)}</span>`), c = l.lastIndex;
    }
    return c < s.length && (d += this.escapeHTML(s.slice(c))), d = d.replace(/\b(0x[0-9a-fA-F]+|\d+\.?\d*|\d*\.\d+)\b/g, (g, a, u) => {
      const p = d[u - 1] || "", m = d[u + g.length] || "";
      return p === "&" || p === "#" || m === ";" || m === "#" ? g : `<span style="color: ${e.number};">${g}</span>`;
    }), d = d.replace(/\b(const|let|var|function|class|if|else|return|for|while|switch|case|break|import|from|export|extends|new|try|catch|finally|throw|await|async|interface|type)\b/g, `<span style="color: ${e.keyword};">$1</span>`), d.replace(/\u0000([a-z]+)\u0000/g, (g, a) => {
      let u = 0;
      for (let p = 0; p < a.length; p++)
        u = u * 26 + (a.charCodeAt(p) - 97 + 1);
      return u = u - 1, i[u] || "";
    });
  }
  _highlightPHP(t, e) {
    const s = this.unescapeEntitiesRepeated(t);
    let i = this.escapeHTML(s);
    const n = [], o = (a) => {
      let u = "", p = a;
      do
        u = String.fromCharCode(97 + p % 26) + u, p = Math.floor(p / 26) - 1;
      while (p >= 0);
      return u || "a";
    }, h = (a) => {
      const u = n.length;
      return n.push(a), `\0${o(u)}\0`;
    }, r = (a, u) => {
      const p = i.indexOf(a);
      return p === -1 ? !1 : (i = i.slice(0, p) + u + i.slice(p + a.length), !0);
    };
    let l;
    const c = /\/\*[\s\S]*?\*\//g, d = /\/\/[^\n\r]*/g, f = /\#([^\n\r]*)/g, g = /("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*')/g;
    for (; l = c.exec(s); ) {
      const a = l[0];
      r(this.escapeHTML(a), h(`<span style="color: ${e.comment};">${this.escapeHTML(a)}</span>`));
    }
    for (; l = d.exec(s); ) {
      const a = l[0];
      r(this.escapeHTML(a), h(`<span style="color: ${e.comment};">${this.escapeHTML(a)}</span>`));
    }
    for (; l = f.exec(s); ) {
      const a = l[0];
      r(this.escapeHTML(a), h(`<span style="color: ${e.comment};">${this.escapeHTML(a)}</span>`));
    }
    for (; l = g.exec(s); ) {
      const a = l[0];
      r(this.escapeHTML(a), h(`<span style="color: ${e.string};">${this.escapeHTML(a)}</span>`));
    }
    return i = i.replace(/(\$[a-zA-Z_\x80-\xff][a-zA-Z0-9_\x80-\xff]*)/g, `<span style="color: ${e.variable};">$1</span>`), i = i.replace(/\b(echo|print|function|class|if|else|elseif|foreach|as|return|namespace|use|new|extends|public|protected|private|static)\b/g, `<span style="color: ${e.keyword};">$1</span>`), i = i.replace(/\u0000([a-z]+)\u0000/g, (a, u) => {
      let p = 0;
      for (let m = 0; m < u.length; m++)
        p = p * 26 + (u.charCodeAt(m) - 97 + 1);
      return p = p - 1, n[p] || "";
    }), i;
  }
  // Method to check if content contains syntax that should be highlighted
  shouldHighlight(t) {
    return /<\/?[\w:-]+|<!--/.test(t);
  }
  destroy() {
    this.editor = null, this.modes.clear();
  }
}
function _(x, t) {
  const e = { ...t };
  return e.extensions || (e.extensions = []), e.extensions.some((n) => n.name === "keymap") || e.extensions.unshift(new H(e.keymap)), e.extensions.some((n) => n.name === "transaction") || e.extensions.unshift(new R()), new $(x, e);
}
export {
  A as BracketMatchingExtension,
  U as CodeFoldingExtension,
  $ as EditorCore,
  H as KeymapExtension,
  N as LineNumbersExtension,
  B as ReadOnlyExtension,
  V as SearchExtension,
  F as SyntaxHighlightingExtension,
  k as TextModel,
  K as ThemeExtension,
  P as View,
  _ as createEditor,
  $ as default
};
